import { LegalPage } from "../../components/LegalPage";

export function Gdpr() {
  return (
    <LegalPage
      title="GDPR / UK GDPR data subject rights"
      description="EU and UK data subject rights under GDPR Articles 15-22: access, rectification, erasure, restriction, portability, objection, and rights related to automated decision-making."
      path="/gdpr"
      effective="2026-05-30"
    >
      <p>
        This page summarises your rights as a data subject under the EU General
        Data Protection Regulation (Regulation 2016/679) and the UK GDPR. For
        the full description of how we process personal data, see our{" "}
        <a href="/privacy">Privacy Policy</a> and{" "}
        <a href="/dpa">Data Processing Agreement</a>.
      </p>

      <h2>Your rights</h2>
      <ul>
        <li><strong>Right of access (Art. 15):</strong> obtain confirmation of whether we process your personal data, and a copy of that data.</li>
        <li><strong>Right to rectification (Art. 16):</strong> correct inaccurate or complete incomplete data.</li>
        <li><strong>Right to erasure (Art. 17):</strong> have your data deleted in defined circumstances.</li>
        <li><strong>Right to restrict processing (Art. 18):</strong> suspend processing while a dispute is resolved.</li>
        <li><strong>Right to data portability (Art. 20):</strong> receive your data in a structured, machine-readable format.</li>
        <li><strong>Right to object (Art. 21):</strong> object to processing based on legitimate interests or for direct marketing.</li>
        <li><strong>Rights related to automated decision-making (Art. 22):</strong> request human review of decisions that produce legal or similarly significant effects (we do not make such decisions on the marketing site).</li>
      </ul>

      <h2>How to exercise your rights</h2>
      <p>
        Email <strong>privacy@weconsultrx.com</strong>. We will acknowledge
        within five business days and respond substantively within one calendar
        month (extendable by two months for complex requests).
      </p>

      <h2>Lodging a complaint</h2>
      <p>
        You have the right to lodge a complaint with the supervisory authority
        in the Member State of your habitual residence (in the UK: the
        Information Commissioner’s Office at ico.org.uk).
      </p>

      <h2>International transfers</h2>
      <p>
        Where we transfer your personal data outside the EEA / UK, we rely on
        the EU Standard Contractual Clauses and the UK International Data
        Transfer Addendum.
      </p>
    </LegalPage>
  );
}
